// https://www.w3.org/TR/2012/WD-html-markup-20121025/input.email.html#form.data.emailaddress_xref2
export const EMAIL_REGEXP =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\.[a-zA-Z0-9-]+)?$/

export const MFA_TOKEN_REGEXP = /https.*?\/admin\/login\/confirm\/(.*?)<\/div>/
export const SHORTLIST_HOR_ID_REGEXP =
  /\/admin\/housing-requests\/(\d+)\/shortlist\/review/gm
